import React, { useState, useEffect } from "react";
import { getInitials } from "../../Utils/helpers";
import { RiMenu2Fill } from "react-icons/ri";
import {
  FaWallet,
  FaRupeeSign,
  FaUser,
  FaEnvelope,
  FaPhone,
} from "react-icons/fa";
import { useWallet } from "../../Context/WalletContext";
import { motion, AnimatePresence } from "framer-motion";

const Navbar = ({ toggleSidebar, user }) => {
  const { balance, loading } = useWallet();
  const [showWallet, setShowWallet] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  const handleRecharge = () => {
    const message = `Hi, I want to recharge my wallet. My Phone number is ${
      user?.phone || ""
    }`;
    const whatsappURL = `https://api.whatsapp.com/send?phone=919914796987&text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappURL, "_blank");
  };

  // // Fetch balance from API
  // useEffect(() => {
  //   const fetchBalance = async () => {
  //     try {
  //       const response = await fetch("/api/user/balance", {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       });
  //       const data = await response.json();
  //       if (response.ok) {
  //         setBalance(data.balance);
  //       } else {
  //         setBalance(0);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching balance:", error);
  //       setBalance(0);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchBalance();
  // }, []);

  return (
    <>
      <div className="w-full h-[68px] py-2 px-6 flex justify-between items-center bg-white border-b border-[#142b70]/10">
        {/* Left: Logo + Hamburger for mobile */}
        <div className="flex items-center gap-4">
          <button
            className="md:hidden p-2 border rounded-lg"
            onClick={toggleSidebar}
          >
            <RiMenu2Fill className="text-brand" />
          </button>
          <div className="text-brand text-xl uppercase font-bold">
            Get Your Info
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-3">
          {/* Wallet Section */}
          {!user?.is_admin && (
            <button
              onClick={() => setShowWallet(true)}
              className="pulse-animate block md:flex items-center gap-1.5 px-1.5 md:px-2.5 py-1.5 rounded-full border border-brand/20 
             bg-white shadow-[inset_0_1px_1px_rgba(255,255,255,0.9),_inset_0_-1px_1px_rgba(0,0,0,0.06),_0_1px_2px_rgba(0,0,0,0.08)] 
             hover:shadow-[inset_0_1px_2px_rgba(255,255,255,1),_inset_0_-1px_2px_rgba(0,0,0,0.08),_0_1px_3px_rgba(0,0,0,0.1)] 
             hover:bg-brand/5 active:scale-[0.98] transition-all duration-200"
            >
              <div className="flex items-center justify-center w-6 h-6 rounded-full bg-brand/10 border border-brand/10">
                <FaWallet className="text-brand text-[15px]" />
              </div>

              <div className="flex items-center text-[13px] font-semibold text-gray-800 leading-none">
                <FaRupeeSign className="hidden sm:block text-brand text-[13px] mr-[1px]" />
                <span className="text-brand font-semibold hidden sm:block">
                  {balance?.toLocaleString("en-IN") ?? 0}
                </span>
              </div>
            </button>
          )}

          {/* User Profile */}
          <button
            onClick={() => setShowProfile(true)}
            className="flex items-center gap-2 bg-gray-300/20 pl-2 md:pl-3 pr-2 md:pr-5 py-2 rounded-full transition cursor-pointer hover:bg-gray-300/40"
          >
            <div className="w-8 h-8 text-xs flex items-center justify-center rounded-full bg-brand text-white font-semibold">
              {getInitials(user?.name)}
            </div>
            <div className="hidden sm:block text-left">
              <p className="text-xs text-brand">{user?.name}</p>
              <p className="text-[10px] text-brand/80">
                {user?.is_admin ? "Admin" : "User"}
              </p>
            </div>
          </button>
        </div>
      </div>
      {/* Profile Modal */}
      <AnimatePresence>
        {showProfile && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
          >
            <motion.div
              initial={{ y: 40, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 40, opacity: 0 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
              className="relative w-full max-w-sm mx-auto bg-white/90 backdrop-blur-xl border border-brand/10 rounded-2xl shadow-lg p-5"
            >
              {/* Close */}
              <button
                onClick={() => setShowProfile(false)}
                className="absolute top-3 right-4 text-gray-400 hover:text-brand transition text-lg"
              >
                ✕
              </button>

              {/* Header */}
              <div className="flex flex-col items-center text-center mt-2 mb-5">
                <div className="w-12 h-12 flex items-center justify-center bg-brand/10 rounded-full mb-2">
                  <FaUser className="text-brand text-lg" />
                </div>
                <h2 className="text-lg font-semibold text-brand">My Profile</h2>
              </div>

              {/* Profile Details */}
              <div
                className="space-y-3 p-4 rounded-2xl border border-gray-100 bg-[#f8f9fa]"
                style={{
                  boxShadow:
                    "inset 0 2px 4px rgba(0,0,0,0.12), inset 0 -2px 4px rgba(255,255,255,0.6), 0 2px 4px rgba(0,0,0,0.08)",
                }}
              >
                <div className="flex items-center gap-3">
                  <FaUser className="text-brand/80" />
                  <p className="text-sm font-medium text-gray-800">
                    {user?.name}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <FaEnvelope className="text-brand/80" />
                  <p className="text-sm text-gray-700">{user?.email}</p>
                </div>
                {user?.phone && (
                  <div className="flex items-center gap-3">
                    <FaPhone className="text-brand/80 rotate-90" />
                    <p className="text-sm text-gray-700">{user?.phone}</p>
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Wallet Modal */}
      <AnimatePresence>
        {showWallet && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
          >
            <motion.div
              initial={{ y: 40, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 40, opacity: 0 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
              className="relative w-full max-w-sm mx-auto bg-white/90 backdrop-blur-xl border border-brand/10 rounded-2xl shadow-lg p-5"
            >
              {/* Close Button */}
              <button
                onClick={() => setShowWallet(false)}
                className="absolute top-3 right-4 text-gray-400 hover:text-brand transition text-lg"
              >
                ✕
              </button>

              {/* Header */}
              <div className="flex flex-col items-center text-center mt-2 mb-5">
                <div className="w-12 h-12 flex items-center justify-center bg-brand/10 rounded-full mb-2">
                  <FaWallet className="text-brand text-lg" />
                </div>
                <h2 className="text-lg font-semibold text-brand">My Wallet</h2>
              </div>

              {/* Wallet Balance Card */}
              <div className="text-center mb-6">
                <p className="text-sm text-gray-500 mb-2">Current Balance</p>

                <div
                  className="inline-flex items-baseline justify-center px-4 py-2 rounded-2xl border border-gray-200 bg-[#f8f9fa] shadow-inner"
                  style={{
                    boxShadow:
                      "inset 0 2px 4px rgba(0,0,0,0.12), inset 0 -2px 4px rgba(255,255,255,0.6), 0 2px 4px rgba(0,0,0,0.08)",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <span className="text-2xl font-semibold text-gray-600 mr-1">
                    <FaRupeeSign className="text-brand text-lg" />
                  </span>
                  <h2
                    className="text-2xl font-extrabold text-gray-900 tracking-tight"
                    style={{
                      fontFamily: "'Inter', 'SF Pro Display', sans-serif",
                      letterSpacing: "-0.5px",
                    }}
                  >
                    {balance?.toLocaleString("en-IN") ?? 0}
                  </h2>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-col gap-2">
                <button
                  onClick={handleRecharge}
                  className="w-full bg-brand hover:bg-brand/90 text-white font-medium py-2.5 rounded-xl shadow-sm transition"
                >
                  Recharge Wallet
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
